/**
 * UtilityColorsSection.tsx
 * Utility Color Scales - raw color scales for specific design needs
 */

import React from 'react';
import { Card, CardHeader, CardBody } from '@enfomentis/ui';
import { Divider } from '@enfomentis/ui';

// Utility colors - raw color scales for specific design use cases
const utilityColorScales = [
  { name: 'blue', desc: 'Blue utility scale - for informational elements' },
  { name: 'gray', desc: 'Gray utility scale - for neutral elements' },
  { name: 'green', desc: 'Green utility scale - for profit/positive indicators' },
  { name: 'red', desc: 'Red utility scale - for loss/negative indicators' },
] as const;

// Color scale shades
const shades = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900'] as const;

export const UtilityColorsSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card shadow="lg" isHoverable>
        <CardHeader>
          <div className="space-y-2">
            <h3 className="text-xl font-semibold text-text-primary">Utility Color Scales</h3>
            <Divider />
            <p className="text-text-secondary">Raw color scales for specific design needs - use sparingly for custom styling</p>
          </div>
        </CardHeader>
        <CardBody>
          <div className="space-y-8">
            {utilityColorScales.map((scale) => (
              <div key={scale.name} className="space-y-4">
                <div>
                  <h4 className="font-semibold text-text-primary capitalize">{scale.name}</h4>
                  <p className="text-sm text-text-secondary">{scale.desc}</p>
                </div>
                
                <div className="grid grid-cols-5 gap-2">
                  {shades.map((shade) => (
                    <div 
                      key={`${scale.name}-${shade}`}
                      className={`h-12 rounded-lg flex flex-col items-center justify-center text-xs font-medium border border-border`}
                      style={{ 
                        backgroundColor: `var(--color-${scale.name}-${shade})`,
                        color: parseInt(shade) >= 500 ? 'white' : 'black'
                      }}
                    >
                      <span>{shade}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};